import React, { useContext, useEffect } from 'react';
import TableauReport from '../../../components/Tableau';
import { buriedPoint, typeIdObj } from '@/pages/home/utils/buriedPoint';
import { StudioContext } from '../context';
import StudioState from '../components/StudioState';

const Tableau = () => {
  const { currentGame, currentMenu, menuPermission } = useContext(StudioContext);
  const {
    url
  } = currentMenu || {};

  const userId = '101';
  const gameCode = currentGame?.game_code || '';
  const studioCode = currentGame?.studio || '';

  useEffect(()=> {
    if(!currentMenu){
      return;
    }

    const { game_code: gameCode } = currentGame;
    const { id = '', name_en: nameEn } = currentMenu || {};
    const logObj = {
      pageId: '100701', 
      menuId: id,
      pageName: nameEn,
      extInfo: nameEn,
      pagePath: `/tableau/report/${nameEn || ''}`,
      uid: gameCode || '',
      typeId: typeIdObj.studio,
      gameName: currentGame?.game_name,
    };
    buriedPoint(logObj);

  },[currentGame, currentMenu]);

  if (menuPermission === false) {
    return <StudioState isNoPermission={true} />;
  }

  return (
    <>
      { 
        url ? <TableauReport className='db-studio-iframe-wrap' url={url} user_id={userId} game_code={gameCode} studio_code={studioCode} style={{padding: '0px'}}/> : <StudioState/> 
      }
    </>
  );
};

export default Tableau;